export const isValidBasketIdResponse = (response) => !!(
  response &&
  response.bid
);

export const GET_BASKET_ID_STORE_PATH = 'token';
export const ERROR_BASKET_ID =
  'Could not add service to the basket. There was an error getting the basket ID.';

export const getBasketId = async (storeUrl) => {
  const getBasketIdUrl = `${storeUrl}/${GET_BASKET_ID_STORE_PATH}`;
  let basketIdResponse;
  try {
    basketIdResponse = await fetch(getBasketIdUrl, {
      method: 'POST',
      credentials: 'include'
    });
  } catch (e) {
    return null;
  }
  const basketIdResponseJSON = await basketIdResponse.json();
  let basketId = null;
  if (isValidBasketIdResponse(basketIdResponseJSON)) {
    basketId = basketIdResponseJSON.bid;
  }

  return basketId;
};
